// src/components/Reports/ClearIndicatorComponent.tsx
// Custom ClearIndicator component for react-select that removes focus after clearing
// This prevents the cursor from staying in the input after clicking the X button

import React from 'react';
import { components } from 'react-select';
import type { ClearIndicatorProps } from 'react-select';

/**
 * Custom ClearIndicator that removes focus from the input after clearing selections.
 * This prevents the cursor from remaining visible in the select after clicking the X button.
 */
export const ClearIndicatorComponent = (props: ClearIndicatorProps<any, any, any>) =>
{
  const blurActiveInput = () =>
  {
    // Use requestAnimationFrame + setTimeout to ensure blur happens after react-select's logic
    requestAnimationFrame(() =>
    {
      setTimeout(() =>
      {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLInputElement)
        {
          activeElement.blur();
        }
      }, 0);
    });
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) =>
  {
    // Call the original handler if it exists
    props.innerProps?.onMouseDown?.(event);
    blurActiveInput();
  };

  const handleTouchEnd = (event: React.TouchEvent<HTMLDivElement>) =>
  {
    // Call the original handler if it exists
    props.innerProps?.onTouchEnd?.(event);
    blurActiveInput();
  };

  return (
    <components.ClearIndicator
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseDown: handleMouseDown,
        onTouchEnd: handleTouchEnd,
      }}
    />
  );
};

export default ClearIndicatorComponent;
